import { render, staticRenderFns } from "./PosItemList.vue?vue&type=template&id=12b2404a&scoped=true&lang=pug&"
import script from "./PosItemList.vue?vue&type=script&lang=js&"
export * from "./PosItemList.vue?vue&type=script&lang=js&"
import style0 from "./PosItemList.vue?vue&type=style&index=0&id=12b2404a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2404a",
  null
  
)

export default component.exports